import { render, staticRenderFns } from "./DetailZone.vue?vue&type=template&id=1ec0c9d1&scoped=true&"
import script from "./DetailZone.vue?vue&type=script&lang=js&"
export * from "./DetailZone.vue?vue&type=script&lang=js&"
import style0 from "./DetailZone.vue?vue&type=style&index=0&id=1ec0c9d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec0c9d1",
  null
  
)

export default component.exports